import React, { useState, useEffect, useContext, useRef } from "react"
import styled from "styled-components"
import BranchMap from "./branchMap"
import withApolloClient from "../withApolloClient"
import { useQuery } from "@apollo/react-hooks"
import {
  Input,
  Button,
  RoundedButton,
  Text,
  Shimmer,
  theme,
  VerticalSpacer,
  inBrowser
} from "@omnichannel/ace-b2b-elements"
import { gql } from "apollo-boost"
import { coordinates } from "../../helpers/geolocation"
import ConfirmCancelModal from "./branchConfirmModal"
import { LocationOn } from "styled-icons/material"
import { Phone } from "@styled-icons/boxicons-regular/Phone"
import useWindowDimensions from "../../helpers/windowDimensions"
import { ChevronDown } from "@styled-icons/boxicons-solid/ChevronDown"
import { ChevronUp } from "@styled-icons/boxicons-solid/ChevronUp"
import { APP_ID } from "../../helpers/constants"
// import { inBrowser } from "../../utils/utils"
import { ActiveBranch } from "../../context/activeBranch"
import { InfoLarge } from "@styled-icons/typicons/InfoLarge"
import { Slash } from "@styled-icons/fa-solid/Slash"
import { ShoppingCart } from "styled-icons/material/ShoppingCart"
import { setBranches } from "../../utils/utils"


const PackageFromIcon = styled(ShoppingCart)`
  width: 1.3rem;
  height: 1.3rem;
  // color: ${props => props.theme[APP_ID].secondary};
  color: ${props => props.theme[APP_ID].tertiary};
  cursor: pointer;
  position: absolute;
  top: .2rem;
  left: 0;
  width: 100%;
  text-align: center;
`
const IconContainer = styled.div`
  position: relative;
  display: inline-block;
  width: 2em;
  height: 2em;
  line-height: 2em;
  vertical-align: middle;
`

const ChevronUpIcon = styled(ChevronUp)`
  width: 2rem;
  height: 2rem;
  color: lightgray;
  cursor: pointer;
`

const ChevronDownIcon = styled(ChevronDown)`
  width: 2rem;
  height: 2rem;
  color: lightgray;
  cursor: pointer;
`

const InfoOutlineIcon = styled(InfoLarge)`
  width: 3rem;
  height: 3rem;
  color: ${props => props.theme[APP_ID].primary};
  background-color: yellow;
  /* border-radius: 2rem; */
  margin-right: 1rem;
  padding: .4rem;
  /* scursor: pointer; */
`

const branchesQuery = gql`
  query branchesByLocationQuery(
    $lat: Float
    $lng: Float
    $distance: Int
    $name: String
    $limit: Int
    $offset: Int
  ) {
    branchesByLocation(
      lat: $lat
      lng: $lng
      distance: $distance
      name: $name
      limit: $limit
      offset: $offset
    ) {
      _id
      name
      lng
      lat
      fbUrl
      address1
      address2
      distance
      close
      open
      schedule
      email
      phone
      isPickup
      isDelivery
    }
  }
`

const DEFAULT_APP_LOCATION = { lng: 121.0300684, lat: 14.65695944 }
const APP_LOCATION = "ace_app_location"
const LOCATION_MAX_AGE = 900000 //milliseconds
const APP_BRANCH_LOCATION = "ace_app_branch"

const MainContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  background-color: #FFF;
  @media (min-width: 961px) {
    padding: 0 4rem;
  }
  @media (min-width: 1200px) {
    padding: 0;
  }
`

const PageTitle = styled.div`
  font-size: 2.6rem;
  font-weight: 600;
`

const BranchName = styled(Text)`
  font-size: 1.6rem;
  line-height: 110%;
  font-weight: 500;
  margin-bottom: .8rem;
  padding-right: 4rem;
  cursor: pointer;
  ${props => props.shouldHighlight ? `color: ${props.theme[APP_ID].tertiary};` : ''}
`

const BranchMapContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`

const SearchAndListBox = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 2rem 0rem 1.2rem 0rem;
  @media (min-width: 961px) {
    width: 45%;
  }
`

const SearchInputBox = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  padding-right: .8rem;
  transform: translateY(-1rem);
`

const MapBox = styled.div`
  display: flex;
  width: 55%;
  justify-content: flex-start;
`

const MainBox = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;  
  width: 100%;
  max-width: 110rem;
  flex-direction: column;
  @media (min-width: 961px) {
    width: 100%;
    flex-direction: row;
  }
`

const TitleAndSearchBox = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 .6rem 0 1.2rem;
  width: 100%;
  @media (min-width: 961px) {
    padding-top: 1.6rem;
    padding-right: 1.6rem;
  }
  @media (min-width: 1200px) {
    padding-right: 5rem;
  }
`

const ResultListBox = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  /* @media (min-width: 961px) {
    margin-top: 1.6rem;
    max-height: 46rem;
    overflow-y: scroll;
    overflow-x: hidden;
  } */
`

const SearchResultCountBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: baseline;
  width: 100%;
  padding: 0 0 0 .4rem;
  font-size: 1.4rem;
`

const BranchBox = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 1.8rem 1.8rem;
  background-color: ${props => props.isSelected ? '#ECECEC' : ''};
  border-bottom-style: ${props => !props.isSelected ? 'solid' : 'none'};
  border-bottom-color: ${props => !props.isSelected ? '#ECECEC' : ''};
  border-bottom-width: .1rem;
  position: relative;
  border-top-style: none;
  &:first-of-type {
    border-top-style: solid;
    border-top-color: #ECECEC;
    border-top-width: .1rem;
  }
  @media (min-width: 1200px) {
    padding-right: 3.6rem;
  }
`

const BranchBoxExpandCollapseBox = styled.div`
  display: flex;
  position: absolute;
  top: 0;
  right: 0;
  width: 4rem;
  height: 4rem;
  padding: 1.6rem 0 0 0;
`

const BranchAddressBox = styled.div`
  line-height: 120%;
  font-size: 1.2rem;
  padding-right: 4rem;
`

const BranchDetailsBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
`

const BranchDetailsTopBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  width: 100%;
  margin-bottom: 1.2rem;
`

const DistanceAndPhoneBox = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;  
`
const DistanceBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;  
  font-size: 1.2rem;
  padding: 2rem 0 1rem .8rem;
`
const BranchDetailBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;  
  font-size: 1.2rem;
  padding: 0rem 0 0rem .8rem;
`

const LocationIcon = styled(LocationOn)`
  width: 1.8rem;
  height: 1.8rem;
  margin-right: .8rem;
  color: red;
  transform: translateY(-.2rem);
`

const PhoneBox = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;  
  padding: 0 0 0 .8rem;
  font-size: 1.2rem;
`

const PhoneIcon = styled(Phone)`
  width: 1.6rem;
  height: 1.6rem;
  margin-right: .8rem;
  color: #000;
`

const NumbersBox = styled.div`
  display: flex;
  max-width: 4rem;
  line-height: 140%;
`

const ShophereBox = styled.div`
  padding: 2rem 1.6rem;
`


const WebView = styled.div`
  display: none;
  @media (min-width: 961px) {
   display: contents;
  }
`

const MobileView = styled.div`
  display: contents;
  @media (min-width: 961px) {
    display: none;
  }
`

const CurrentlyShoppingLabelBox = styled.div`
  display: flex;
  width: 100%;
  transform: translate(2rem, -.6rem);
`


const LocationInfoBox = styled.div`
  display: flex;
  justify-content: center;
  align-items:center;
  padding: 2rem 2rem 0 2rem;
  font-size: 1.4rem;
  @media (min-width: 961px) {
    padding: 2rem;
  }
`


const Branch = ({
  branch,
  onClick,
  isSelected,
  width,
  setAsShoppingBranch,
  onClickChevronUp,
  onClickChevronDown,
  isPickup,
  isDelivery
}) => {

  const branchFromStorage = JSON.parse(
    (inBrowser && localStorage.getItem("ace_app_branch")) || "{}"
  )
  let branchIdFromStorage = branchFromStorage._id

  const dotIndex = branch.distance.toString().indexOf(".")
  const distance = branch.distance.toString().substr(0, dotIndex + 3)

  const getPickupIcon = _ => {
    return (
      <IconContainer>
        <PackageFromIcon />
      </IconContainer>
    )
  }

  return (
    <BranchBox onClick={onClick} isSelected={isSelected}>
      <BranchBoxExpandCollapseBox>
        {isSelected ? <ChevronUpIcon onClick={(e) => {
          e.stopPropagation()
          onClickChevronUp()

        }} /> : <ChevronDownIcon onClick={(e) => {
          onClickChevronDown()
          e.stopPropagation()
        }} />}
      </BranchBoxExpandCollapseBox>
      <BranchName shouldHighlight={isPickup}>
        {branch.name}
        {isPickup ? getPickupIcon() : ``}
      </BranchName>
      <BranchAddressBox>
        {branch.address1} {branch.address2}
      </BranchAddressBox>
      {
        isSelected &&
        <BranchDetailsBox>
          <BranchDetailsTopBox>
            <DistanceAndPhoneBox>
              <DistanceBox><LocationIcon /> {distance} km</DistanceBox>
              <PhoneBox><PhoneIcon /><NumbersBox>{branch.phone.split(",")}</NumbersBox></PhoneBox>
            </DistanceAndPhoneBox>
            {(isPickup) ?
              (<ShophereBox>
                {
                  branchIdFromStorage !== branch._id ? (<RoundedButton primary padding={'.7rem 4rem .6rem 4rem'}
                    onClick={setAsShoppingBranch}
                  >
                    <div style={{ whiteSpace: 'nowrap' }}>Shop here</div>
                  </RoundedButton>)
                    :
                    (
                      <CurrentlyShoppingLabelBox>
                        <RoundedButton disabled padding={'.7rem 1rem .6rem 1rem'} width={'100%'} >
                          <div style={{ whiteSpace: 'nowrap', color: theme[APP_ID].redlabel, fontWeight: '500', }}>Currently shopping here</div>
                        </RoundedButton>
                      </CurrentlyShoppingLabelBox>
                    )
                }

              </ShophereBox>)
              :
              <ShophereBox style={{ padding: "2.2rem .4rem 0 0", whiteSpace: "nowrap" }}>* Not available online</ShophereBox>
            }
          </BranchDetailsTopBox>
          <MobileView>
            <BranchMapContainer>
              <BranchMap
                branch={branch}
                width={width}
                height={150}
              />
            </BranchMapContainer>
          </MobileView>
        </BranchDetailsBox>
      }
    </BranchBox>
  )
}

const StoreLocator = withApolloClient(
  () => {
    const activeBranchContext = useContext(ActiveBranch)
    const [search, setSearch] = useState("")
    const [name, setName] = useState("")
    const [currentLocation, setCurrentLocation] = useState(DEFAULT_APP_LOCATION)
    const [showConfirmModal, setShowConfirmModal] = useState(false)
    // const [showLocationInfoModal, setShowLocationInfoModal] = useState(false)
    const [selectedBranch, setSelectedBranch] = useState(null)
    const [lastSelectedBranch, setLastSelectedBranch] = useState(null)
    const { width } = useWindowDimensions()
    const webViewMapBoxRef = useRef(null)
    const [webViewWidth, setWebViewWidth] = useState(width - 500);
    const searchAndListBoxRef = useRef(null)
    const [mobileViewWidth, setMobileViewWidth] = useState(360)

    if (webViewMapBoxRef.current && width >= 961) {
      const current = webViewMapBoxRef.current
      // console.log("1 width::", current.offsetWidth)
      if (webViewWidth !== current.offsetWidth) {
        // console.log("2 width::", current.offsetWidth)
        setWebViewWidth(current.offsetWidth)
      }
    }

    if (searchAndListBoxRef.current && width < 961) {
      const currentMobile = searchAndListBoxRef.current
      // console.log("1 width::", currentMobile.offsetWidth)
      if (mobileViewWidth !== currentMobile.offsetWidth) {
        // console.log("2 width::", currentMobile.offsetWidth)
        setMobileViewWidth(currentMobile.offsetWidth)
      }
    }


    useEffect(() => {
      if (navigator.geolocation) {
        const appLocation = JSON.parse(localStorage.getItem(APP_LOCATION))
        if (appLocation) {
          setCurrentLocation(appLocation)
          const { timestamp } = appLocation
          if (timestamp) {
            const age = new Date().getTime() - timestamp
            if (age > LOCATION_MAX_AGE) {
              getLocation()
            }
          } else {
            getLocation()
          }
        } else {
          getLocation()
        }
      } else {
        localStorage.setItem(APP_LOCATION, JSON.stringify(DEFAULT_APP_LOCATION))
      }

    }, [])

    const getLocation = () => {
      coordinates()
        .then(location => {
          setCurrentLocation(location)
          localStorage.setItem(APP_LOCATION, JSON.stringify(location))
        })
        .catch(e => {
          localStorage.setItem(
            APP_LOCATION,
            JSON.stringify(DEFAULT_APP_LOCATION)
          )
        })
    }

    const confirmSaveBranch = branch => {
      setShowConfirmModal(true)
    }

    const saveBranch = branch => {
      localStorage.setItem(
        APP_BRANCH_LOCATION,
        JSON.stringify({ ...branch, userSaved: true })
      )
    }

    const {
      data: branchesData,
      loading: branchesLoading,
      fetchMore,
    } = useQuery(branchesQuery, {
      variables: {
        name: name ? name : "",
        distance: 20000,
        limit: 200,
        lat: currentLocation.lat,
        lng: currentLocation.lng,
      },
    })

    const onChange = e => {
      setSearch(e.target.value)
    }

    const onKeyPress = event => {
      if (event.keyCode === 13) {
        setName(search)
        setSelectedBranch(null)
        setLastSelectedBranch(null)
        event.stopPropagation();
      }
    }

    const handleSearchClick = () => {
      setName(search)
      setSelectedBranch(null)
      setLastSelectedBranch(null)
    }

    let list = []
    if (!branchesLoading && branchesData) {
      if (branchesData.branchesByLocation.length > 0) {
        if (!selectedBranch && !lastSelectedBranch) {
          setSelectedBranch(branchesData.branchesByLocation[0])
          setLastSelectedBranch(branchesData.branchesByLocation[0])
        }
        list = branchesData.branchesByLocation
        setBranches(JSON.stringify(list))
      }
    }


    const handleBranchClick = (branch) => {
      setSelectedBranch(branch)
      setLastSelectedBranch(branch)
    }

    const handleCollapse = () => {
      setSelectedBranch(null)
    }


    return branchesLoading ? (
      <Shimmer />
    ) : (
        <MainContainer>
          {(activeBranchContext.error === 1) && (
            <LocationInfoBox>
              <InfoOutlineIcon />
              <div style={{ width: '100%', textAlign: 'justify' }}>Please allow Ace Hardware Philippines to use your device's Location Services for us to suggest a list of branches based on your location.</div>
            </LocationInfoBox>
          )}
          <MainBox>
            <SearchAndListBox ref={searchAndListBoxRef} >
              <TitleAndSearchBox>
                <PageTitle>Store Locator</PageTitle>
                <SearchInputBox>
                  <Input
                    placeholder="Branch Name, Address, or City"
                    rightComponent={
                      <Button
                        style={{
                          color: "#FFF",

                          borderRadius: ".4rem",
                          borderTopLeftRadius: "0",
                          borderBottomLeftRadius: "0",
                          width: "9rem",
                          marginLeft: "-0.35rem",
                          // height: "2rem",
                          // transform: "translateY(.1rem)",
                          border: "none",
                          borderBottom: "none", //"1px solid #E0E1E2",
                          // backgroundColor: theme[APP_ID].secondary,
                          backgroundColor: theme.default.primary,
                        }}
                        clickAnimation="highlight"
                        onClick={handleSearchClick}
                        fontSize={"1.6rem"}
                        fontWeight={"600"}
                      >
                        Search
                      </Button>
                    }
                    rightComponentProps={{
                      width: "auto",
                    }}
                    value={search}
                    onChange={onChange}
                    onKeyDown={onKeyPress}
                  />
                </SearchInputBox>
                {list.length ? <SearchResultCountBox><span style={{ fontSize: "1.6rem" }}>{list.length}</span>&nbsp;{list.length > 1 ? 'results' : 'result'} found</SearchResultCountBox> : <SearchResultCountBox>No results found</SearchResultCountBox>}
              </TitleAndSearchBox>
              {list.length > 0 && (
                <ResultListBox>
                  <hr />
                  {/* <div> */}
                  {
                    list.map((branch, i) => {
                      return (
                        <Branch
                          key={i}
                          width={mobileViewWidth - 32}
                          branch={branch}
                          onClickChevronUp={handleCollapse}
                          onClickChevronDown={() => handleBranchClick(branch)}
                          setAsShoppingBranch={() => {
                            confirmSaveBranch(branch)
                            // refreshBranch()
                          }}
                          onClick={() => {
                            handleBranchClick(branch)
                          }}
                          isSelected={branch._id === (selectedBranch ? selectedBranch._id : null)}
                          isPickup={branch.isPickup}
                          isDelivery={branch.isDelivery}
                        />
                      )
                    })
                  }
                  {/* </div> */}
                </ResultListBox>
              )}
            </SearchAndListBox>
            <WebView>
              <MapBox ref={webViewMapBoxRef}>
                {lastSelectedBranch ? (
                  <BranchMapContainer>
                    <BranchMap
                      branch={lastSelectedBranch}
                      width={webViewWidth}
                      height={webViewWidth}
                    />
                  </BranchMapContainer>
                ) : null}
              </MapBox>
            </WebView>
          </MainBox>

          <ConfirmCancelModal
            open={showConfirmModal}
            handleClose={() => {
              setShowConfirmModal(false)
            }}
            branchName={selectedBranch?.name}
            handleSubmit={() => {
              saveBranch(selectedBranch)
              activeBranchContext.refreshBranch()
            }}
          />
        </MainContainer>
      )
  },
  { client: "seeAllClient" }
)

export default StoreLocator
